import { Injectable } from '@angular/core';
import { RequestService } from '../request/request.service';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  constructor(private _requestService: RequestService) {}

  async requestPermission() {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'denied') {
      return;
    }

    try {
      const swRegistration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
      );
      const app = initializeApp(environment.firebaseConfig);
      const messaging = getMessaging(app);

      const token = await getToken(messaging, {
        vapidKey: environment.vapidKey,
        serviceWorkerRegistration: swRegistration,
      });

      if (token) {
        this.saveToken(token).subscribe();
      } else {
        console.warn('Token FCM não foi gerado.');
      }
    } catch (err) {
      console.error('Erro ao registrar SW ou obter token:', err);
      throw err;
    }
  }

  saveToken(token: string) {
    const loginId = parseInt(localStorage.getItem('userId') || '0', 10);
    const data = {
      fcmToken: token,
      loginId: loginId,
    };
    return this._requestService.requestMethod(
      'user/api/User/webPush/subscribe',
      'POST',
      true,
      data,
    );
  }

  listenForMessages() {
    const app = initializeApp(environment.firebaseConfig);
    const messaging = getMessaging(app);

    onMessage(messaging, (message) => {
      if (message.data) {
        new Notification(message.data['title'], {
          body: message.data['body'],
          icon: message.data['icon'],
        });
      }
    });
  }

  subscribeToWebPush(subscription: any) {
    const loginId = parseInt(localStorage.getItem('userId') || '0', 10);
    const data = {
      ...subscription,
      loginId: loginId,
    };
    return this._requestService.requestMethod(
      'user/api/User/webPush/subscribe',
      'POST',
      true,
      data,
    );
  }
}
